<div class="gbd-card-photos" [class.gbd-card-photos--busy]="isSaving()">
  <tidy-file-upload
    [id]="pickerId()"
    [multiple]="true"
    [showTextLink]="true"
    [showPreview]="false"
    [label]="'+ Add photos'"
    (addedImagesChange)="onPhotosAdded($event)"
    (fileError)="onFileError($event)" />

  @if (photos().length) {
    <div class="gbd-photos">
      @for (photo of photos(); track photo.id) {
        <div class="gbd-photo gbd-photo--removable">
          <tidy-image [src]="photo.photo_url" class="gbd-photo__img" />
          <tidy-small-round-button
            class="gbd-photo__remove"
            [image]="'assets/svg/delete.svg'"
            [buttonClass]="'small'"
            (buttonClick)="onPhotoRemoved(photo.id)" />
        </div>
      }
    </div>
  }
</div>
